(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.quotes = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var jacobson_behindEveryChild = exports.jacobson_behindEveryChild = {
    content: 'Behind every young child who believes in herself or himself, is a parent who believed first.',
    author: 'Matthew Jacobson'
  };

  var franklin_involveMe = exports.franklin_involveMe = {
    content: 'Tell me and I forget, teach me and I may remember, involve me and I learn.',
    author: 'Benjamin Franklin'
  };

  // Pricing Page:

  var roberts_goGreen = exports.roberts_goGreen = {
    content: 'Over the past four years Chesapeake Public Schools has saved over 28,176,074 sheets of paper and saved approximately 3,381 trees with Peachjar\'s "Go Green" initiative.',
    author: 'James T. Roberts, Ph.D.',
    authorTitle: 'Superintendent, Chesapeake Public Schools, Virginia'
  };

  // School Info Page:

  var maldonado_helpsMeStayConnected = exports.maldonado_helpsMeStayConnected = {
    content: 'Peachjar helps me stay more connected with my schools and parents. Furthermore, our community has been very enthusiastic about this initiative. We love Peachjar!',
    author: 'Raul Maldonado',
    authorTitle: 'Superintendent, Palmdale School District, California'
  };

  // Thank You For Requesting Proposal Page:

  var grayson_modernizing = exports.grayson_modernizing = {
    content: 'There are so many great things going on in our schools and in our community. Peachjar gives us another, more modern method of communicating with parents.',
    author: 'Justin Grayson',
    authorTitle: 'Public Information Officer, Riverside Unified School District, California'
  };

  // Create Your Account Page:

  var voelpel_savesTeacherTime = exports.voelpel_savesTeacherTime = {
    content: 'Peachjar has been a godsend. We now know that flyers get to our parents electronically without taking any class instruction time away from teachers.',
    author: 'Daniel Voelpel',
    authorTitle: 'Public Information Director for Tacoma Public Schools, Washington'
  };

  // Verify Your Email Page:

  var duncan_cutsThroughTheClutter = exports.duncan_cutsThroughTheClutter = {
    content: 'Parents today are blasted with automated calls, endless posts and tweets. Peachjar helps us cut through the clutter by delivering targeted flyers with engaging and interactive designs directly to our parents.',
    author: 'Dr. Michael Duncan',
    authorTitle: 'Superintendent, Pike County Schools, Georgia'
  };

  // Payment Page:

  var laPak_goodStewards = exports.laPak_goodStewards = {
    content: 'We are always looking for ways to improve efficiency in the WSD and to be good stewards of taxpayer dollars, so moving to Peachjar was a slam-dunk for our district and our community.',
    author: 'Mary K. LaPak',
    authorTitle: 'Director of Community Relations, Wentzville R - IV, Missouri'
  };

  // Link Expired Page:

  var duncan_lastsLongerThanACatVideo = exports.duncan_lastsLongerThanACatVideo = {
    content: 'If you want important information to last longer than a news cycle or a trending cat video, give Peachjar a try.',
    author: 'Dr. Michael Duncan',
    authorTitle: 'Superintendent, Pike County Schools, Georgia'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/copy/quotes.js
// module id = 2281
// module chunks = 1